import React from 'react';

/**
 * AppFooter renders a legal footer on every page of the application.
 *
 * Contains four legal links required by LEGAL-10:
 * - Terms of Service (cogslog.com/terms)
 * - Privacy Policy (cogslog.com/privacy)
 * - Cookie Preferences — dispatches 'open-cookie-preferences' custom event,
 *   which CookieBanner listens for and responds to by opening CookiePreferencesModal
 * - Do Not Sell or Share My Personal Information (cogslog.com/privacy#do-not-sell)
 *
 * All external links open in a new tab with noopener noreferrer for security.
 * Copyright notice shows the current year automatically.
 *
 * @returns {React.ReactElement} Footer element with legal links and copyright
 * @example
 * <AppFooter />
 */
function AppFooter() {
  const currentYear = new Date().getFullYear();

  /**
   * Dispatch a custom event to open the cookie preferences modal.
   * CookieBanner listens for 'open-cookie-preferences' on window.
   *
   * @param {React.SyntheticEvent} e - Click event
   */
  function handleCookiePreferencesClick(e) {
    e.preventDefault();
    window.dispatchEvent(new CustomEvent('open-cookie-preferences'));
  }

  return (
    <footer className="app-footer" role="contentinfo">
      <div className="app-footer__links">
        <a
          href="https://cogslog.com/terms"
          target="_blank"
          rel="noopener noreferrer"
          className="app-footer__link"
        >
          Terms of Service
        </a>
        <a
          href="https://cogslog.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
          className="app-footer__link"
        >
          Privacy Policy
        </a>
        <button
          type="button"
          className="app-footer__link app-footer__link--btn"
          onClick={handleCookiePreferencesClick}
          aria-haspopup="dialog"
        >
          Cookie Preferences
        </button>
        <a
          href="https://cogslog.com/privacy#do-not-sell"
          target="_blank"
          rel="noopener noreferrer"
          className="app-footer__link"
        >
          Do Not Sell or Share My Personal Information
        </a>
      </div>
      <p className="app-footer__copyright">
        &copy; {currentYear} COGSLOG. All rights reserved.
      </p>
    </footer>
  );
}

export default AppFooter;
